module.exports = __webpack_public_path__ + "img/Nashville.86b3f1d2.png";